import { render, staticRenderFns } from "./GoodsPickers.vue?vue&type=template&id=06d46c88&scoped=true&"
import script from "./GoodsPickers.vue?vue&type=script&lang=js&"
export * from "./GoodsPickers.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPickers.vue?vue&type=style&index=0&id=06d46c88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d46c88",
  null
  
)

export default component.exports